import * as React from 'react';
import { SurfaceContextWithProperties } from '../../../types/contexts';
import { createSurfaceContextWithPropertiesProvider } from '../../common/surface-context-provider';

export interface ConnectWithVSCodeDialogContextProperties {
    devBoxUri: string;
}

export const ConnectWithVSCodeDialogContext = React.createContext<
    SurfaceContextWithProperties<ConnectWithVSCodeDialogContextProperties>
>({ isOpen: false });

export const ConnectWithVSCodeDialogContextProvider =
    createSurfaceContextWithPropertiesProvider<ConnectWithVSCodeDialogContextProperties>(
        ConnectWithVSCodeDialogContext
    );
